import axios, { AxiosRequestConfig, HttpStatusCode, isAxiosError } from "axios";

import { DO_INTERVIEW_SERVICE_URL } from "../constants/AppConstants";
import { EErrorLevel, EErrorSource, errorLogger } from "./ubaTracking.utils";

const APIRequestWithCredential = axios.create({
  withCredentials: true,
});

const APIRequest = axios.create({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToInterview = async <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: HttpStatusCode[],
) => {
  try {
    // eslint-disable-next-line no-param-reassign
    requestData.baseURL = DO_INTERVIEW_SERVICE_URL;
    return await APIRequest<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      // UBA: errorLog - api
      errorLogger(error, EErrorLevel.HIGH, EErrorSource.API, requestData.data);
    }
    return Promise.reject(error);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToInterviewWithCredential = async <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: HttpStatusCode[],
) => {
  try {
    // eslint-disable-next-line no-param-reassign
    requestData.baseURL = DO_INTERVIEW_SERVICE_URL;
    return await APIRequestWithCredential<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      // UBA: errorLog - api
      errorLogger(error, EErrorLevel.HIGH, EErrorSource.API, requestData.data);
    }
    return Promise.reject(error);
  }
};
